import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatisTcfd = () => {
  const urlConfig = {
    name: "Tcfd.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/TCFD.zip",
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="TCFD"
            title={"TCFD Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Box
        sx={{
          borderRadius: "8px",
          padding: "24px",
          top: "226px",
          left: "75px",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            component="h4"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 800,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
              mb: 1,
            }}
          >
            What is TCFD? — Brief introduction
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "-2%",
              color: "#4F4F4F",
            }}
          >
            The Task Force on Climate-related Financial Disclosures (TCFD) is an
            international framework developed by the Financial Stability Board
            to guide organizations in reporting climate-related financial risks
            and opportunities in a structured and transparent way. TCFD’s
            recommendations are organized around four core pillars: Governance,
            Strategy, Risk Management, and Metrics & Targets. It emphasizes both
            physical risks (e.g., extreme weather) and transition risks (e.g.,
            regulatory changes, market shifts, technological disruption), as
            well as climate-related opportunities. The framework encourages
            scenario analysis to assess business resilience under different
            climate futures and requires disclosure of quantitative metrics like
            greenhouse gas (GHG) emissions and climate targets. Globally adopted
            by regulators, investors, and listed companies, TCFD plays a
            critical role in integrating climate risk into mainstream financial
            reporting and aligning corporate disclosure with global climate
            commitments, including those under the Paris Agreement.{" "}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* <a
                    href="https://www.fsb-tcfd.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                >
                    <CustomButton title="Task Force on Climate-Related Financial Disclosures" />
                </a> */}
        <DownloadZipButton
          config={urlConfig}
          title="Task Force on Climate-Related Financial Disclosures"
          externalHref="https://www.fsb-tcfd.org/"
        />
      </Box>
    </Grid>
  );
};

export default WhatisTcfd;
